import { ChevronRightIcon } from '@heroicons/react/20/solid'
import { Link } from '@remix-run/react'

export default function Hero() {
	return (
		<div className="relative isolate overflow-hidden ">
			<div className="container px-4 sm:pb-32 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:px-8 lg:py-10">
				<div className="px-6 lg:px-0 lg:pt-4">
					<div className="mx-auto max-w-2xl">
						<div className="max-w-lg">
							<div className="mt-16 sm:mt-32 lg:mt-16">
								<Link to="/app/dashboard" className="inline-flex space-x-6">
									<span className="rounded-full bg-indigo-600/10 px-3 py-1 text-sm font-semibold leading-6 text-muted-foreground ring-1 ring-inset ring-indigo-600/10">
										Get Started
									</span>
									<span className="inline-flex items-center space-x-2 text-sm font-medium leading-6">
										<span>Just shipped v0.1.0</span>
										<ChevronRightIcon
											className="h-5 w-5 text-gray-400"
											aria-hidden="true"
										/>
									</span>
								</Link>
							</div>
							<h1 className="mt-10 text-4xl font-bold tracking-tight text-foreground sm:text-6xl">
								Revolutionize Your EdTech Platform
							</h1>
							<p className="mt-6 text-lg leading-8 ">
								Question API provides an unparalleled access to our database
								that transforms educational platforms, e-learning sites, and
								academic applications. Enhance your users' learning experience
								by integrating our robust question bank, tailored to fit all
								educational needs.
							</p>
							<div className="mt-10 flex items-center gap-x-6">
								<Link
									to="/app/api-docs"
									className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
								>
									Documentation
								</Link>
							</div>
						</div>
					</div>
				</div>
				<div className="mt-20 sm:mt-24 md:mx-auto md:max-w-2xl lg:mx-0 lg:mt-0 lg:w-screen">
					<div
						className="absolute inset-y-0 right-1/2 -z-10 -mr-10 w-[200%] skew-x-[-30deg]  shadow-xl shadow-indigo-600/10 ring-1 ring-indigo-50 md:-mr-20 lg:-mr-36"
						aria-hidden="true"
					/>
					<div className="shadow-lg md:rounded-3xl">
						<div className="bg-indigo-500 [clip-path:inset(0)] md:[clip-path:inset(0_round_theme(borderRadius.3xl))]">
							<div
								className="absolute -inset-y-px left-1/2 -z-10 ml-10 w-[200%] skew-x-[-30deg] bg-indigo-100 opacity-20 ring-1 ring-inset ring-white md:ml-20 lg:ml-36"
								aria-hidden="true"
							/>
							<img
								src="/img/code-sample.webp"
								alt="Question API integration code sample"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
